import {
  SET__MESSAGE,
  REMOVE__MESSAGE,
  MESSAGING_LOAD_CONVERSATIONS,
} from 'features/messaging/actions/action-types';
import { MessagesReducerInitialState } from './initial-state';

export const MessagesReducer = (
  state = MessagesReducerInitialState,
  { type, payload, status }
) => {
  switch (type) {
    case SET__MESSAGE: {
      if (status === 'request') return state;

      if (status === 'success') {
        return {
          message: payload,
        };
      }
      return state;
    }

    case REMOVE__MESSAGE: {
      if (status === 'request') return state;
      if (status === 'success') {
        return {
          ...payload,
        };
      }
      return state;
    }

    case MESSAGING_LOAD_CONVERSATIONS: {
      if (status === 'request' || !payload) return state;

      if (!Array.isArray(payload)) return state;

      const conversationsByConversationSid = payload?.reduce(
        (acc, conversation) => {
          acc[conversation.externalId] = {
            id: conversation.id,
            sid: conversation.externalId,
            friendlyName: conversation.friendlyName,
            attributes: { archived: conversation.isArchived },
            dateCreated: conversation.dateConversationCreated,
            dateUpdated: conversation.dateConversationUpdated,
            friendlyName: conversation.friendlyName,
            uniqueName: conversation.uniqueName,
            lastMessageCreated: conversation.lastMessageCreated,
            lastMessageIndex: conversation.lastMessageIndex,
            unreadMessagesCount: conversation.unreadMessagesCount,
            numParticipants: conversation.numParticipants,
            source: 'server',
            client: conversation.client,
          };
          return acc;
        },
        {}
      );

      return {
        ...state,
        conversationsByConversationSid,
      };
    }

    default:
      return state;
  }
};

export default MessagesReducer;
